import { render, staticRenderFns } from "./GenelIslemFormWizard.vue?vue&type=template&id=bcc4585e&scoped=true"
import script from "./GenelIslemFormWizard.vue?vue&type=script&lang=ts"
export * from "./GenelIslemFormWizard.vue?vue&type=script&lang=ts"
import style0 from "./GenelIslemFormWizard.vue?vue&type=style&index=0&id=bcc4585e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc4585e",
  null
  
)

export default component.exports